import { BoxProps, Overlay, Transition } from '@mantine/core';
import { useUnit } from 'effector-react';
import { adminLayoutModel } from 'pages/admin-layout/model';

export const AdminLayoutOverlay = ({ ...props }: BoxProps) => {
	const [modalsOpened, closeModals] = useUnit([
		adminLayoutModel.$modalsOpened,
		adminLayoutModel.closeModals,
	]);

	return (
		<Transition
			mounted={modalsOpened}
			duration={150}
		>
			{(styles) => (
				<Overlay
					zIndex={100}
					style={styles}
					onClick={closeModals}
					{...props}
				/>
			)}
		</Transition>
	);
};
